var _circle, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBridge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "url(#paint0_linear_20377_57869)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.70007 11.64V17.38H9.98006C9.98006 14.6629 12.183 12.46 14.9 12.46C17.6171 12.46 19.82 14.6629 19.82 17.38H23.1V11.64C23.1 11.64 18.1657 10 14.9 10C11.6344 10 6.70007 11.64 6.70007 11.64Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 19.495L7.85061 18.9398C8.60036 18.7149 9.39964 18.7149 10.1494 18.9398L10.8506 19.1502C11.6004 19.3751 12.3996 19.3751 13.1494 19.1502L13.8506 18.9398C14.6004 18.7149 15.3996 18.7149 16.1494 18.9398L16.8506 19.1502C17.6004 19.3751 18.3996 19.3751 19.1494 19.1502L19.8506 18.9398C20.6004 18.7149 21.3996 18.7149 22.1494 18.9398L24 19.495",
    stroke: "white",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20377_57869",
    x1: 15,
    y1: 0,
    x2: 15,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37B06F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#199251"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridge);
export default __webpack_public_path__ + "static/media/bridge.7d9004747627b2d03853c9b3ae46e5ea.svg";
export { ForwardRef as ReactComponent };